export type ModuloLiberado = {
  cd_modulo: string;
  dt_termino?: string | Date | null;
};

function toDateOnly(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function isModuloAtivo(mod?: ModuloLiberado | null, hoje = new Date()): boolean {
  if (!mod) return false;
  if (!mod.dt_termino) return true;

  const end = mod.dt_termino instanceof Date ? mod.dt_termino : new Date(mod.dt_termino);
  if (isNaN(end.getTime())) return false;

  return toDateOnly(end).getTime() >= toDateOnly(hoje).getTime();
}

export function buildModulosAtivosSet(mods: ModuloLiberado[] = [], hoje = new Date()): Set<string> {
  return new Set(
    mods
      .filter(m => isModuloAtivo(m, hoje))
      .map(m => (m.cd_modulo || '').toLowerCase().trim())
      .filter(Boolean),
  );
}

export function hasModuloAtivo(codigo: string, ativos: Set<string> | string[]): boolean {
  if (!codigo) {
    throw Error('Código não informado');
  }
  const lowerCodigo = codigo.toLowerCase();
  if (Array.isArray(ativos)) {
    return ativos.includes(lowerCodigo);
  }
  return ativos.has(lowerCodigo);
}
